module.exports = __webpack_public_path__ + "static/media/CARD_ELITE@3x.3eec8c38.png";